/**
 * Outsourcing Module Schemas
 * Nhà cung cấp gia công và Đơn gia công
 */
import { z } from 'zod';
import { optPhone } from './customer.schema';

const optStr = (max = 200) => z.preprocess(
    (v) => (v === null || v === undefined ? undefined : v),
    z.string().max(max).optional().or(z.literal(''))
);

export const vendorFormSchema = z.object({
    code: optStr(30),
    name: z.string().min(1, 'Tên NCC không được để trống').max(200, 'Tối đa 200 ký tự').transform(v => v.toUpperCase()),
    shortName: z.string().max(50).optional().or(z.literal('')).transform(v => v ? v.toUpperCase() : v),
    type: optStr(50),
    group: optStr(50),
    address: optStr(500),
    taxCode: optStr(20),
    representative: optStr(100),
    phone: z.preprocess((v) => (v === null || v === undefined ? undefined : v), optPhone('Số điện thoại')),
    website: optStr(200),
    contactPerson: optStr(100),
    mobile: z.preprocess((v) => (v === null || v === undefined ? undefined : v), optPhone('Số điện thoại di động')),
    email: z.string().email('Email không hợp lệ').optional().or(z.literal('')),
    deliveryAddress: optStr(500),
    transitAddress: optStr(500),
    bankName: optStr(100),
    bankAccountNumber: optStr(30),
    bankAccountHolder: optStr(100),
    initialDebt: z.preprocess((v) => (v === '' ? undefined : v), z.coerce.number().min(0).optional()),
    notes: optStr(1000),
    tags: optStr(500),
});

export type VendorFormData = z.infer<typeof vendorFormSchema>;
export interface Vendor {
    code: string;
    name: string;
    type: string;
    address: string;
    contactPerson: string;
    phone: string;
    mobile: string;
    email: string;
    services?: string[];
    rating?: number;
    paymentTerms?: string;
    taxCode?: string;
    website?: string;
    fanpage?: string | null;
    creditLimit?: number | null;
    bankName?: string;
    bankAccount?: string;
    debtLimit?: string;
    leadTime?: number;
}

export interface OutsourcePO {
    poId: string;
    orderId?: string;
    poReference?: string;
    deploymentModel?: string;
    vendorId: string;
    vendorName: string;
    productName?: string;
    product?: {
        name: string;
        specs: string;
    };
    qtyOrdered: number;
    qtyReceived: number;
    qtyAccepted?: number;
    qtyRejected?: number;
    unitPrice: number;
    totalAmount: number;
    issueDate: string;
    expectedDate: string;
    actualReceiveDate?: string;
    status: string;
    paymentStatus?: string;
}
